import { getTestIds } from '../../../utils/TestIds';
export const GetRichTextEditorTID = (parentTestId)=>getTestIds(parentTestId);
